import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InsightBadge } from './InsightBadge';

// import Swiper core and required components
import SwiperCore, { Scrollbar } from 'swiper';
import {
  Breakpoint,
  MediaQueryService
} from '../../../services/media-query.service';
import { Observable } from 'rxjs';

SwiperCore.use([Scrollbar]);

@Component({
  selector: 'app-insight-badges',
  templateUrl: './insight-badges.component.html',
  styleUrls: ['./insight-badges.component.scss']
})
export class AppInsightBadgesComponent implements OnInit {
  @Input() badges: InsightBadge[];
  @Input() data: any;
  @Output() anchorClick = new EventEmitter<string>();

  desktop$: Observable<boolean>;
  tablet$: Observable<boolean>;
  mobile$: Observable<boolean>;

  constructor(private mediaQueryService: MediaQueryService) {}

  ngOnInit() {
    this.desktop$ = this.mediaQueryService.gt(Breakpoint.md);
    this.tablet$ = this.mediaQueryService.lt(Breakpoint.lg);
    this.mobile$ = this.mediaQueryService.lt(Breakpoint.md);
  }

  onAnchorClick(anchor: string) {
    if (anchor) {
      this.anchorClick.emit(anchor);
    }
  }
}
